/**
 * @license lucide-vue-next v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const Slash = createLucideIcon("slash", [["path", { d: "M22 2 2 22", key: "y4kqgn" }]]);

export { Slash as default };
//# sourceMappingURL=slash.js.map
